import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  category: {
    id: 'GeneralMeetingsSm.category',
    defaultMessage: 'Kategoria:'
  }
});



// WEBPACK FOOTER //
// ./src/views/GeneralMeetings/GeneralMeetingsSm.intl.js